export enum SprayState {
  NotUsed,
  YesUsed
}
